import { createContext, useState, useRef, useEffect } from 'react';
import config from '../../constants/settings';

export const WebsocketContext = createContext([false, null, () => {}]);

export const WebsocketService = ({
  children,
  filtersOpts,
  setListServices,
  setLoading,
  uuid,
  reloadList,
  listServices,
  allowedActions
}) => {
  const [isReady, setIsReady] = useState(false);
  const ws = useRef(null);
  const filtersSent = useRef(false);

  useEffect(() => {
    if (!uuid) {
      return;
    }

    const encodedSub = encodeURIComponent(uuid);

    const socket = new WebSocket(`${config.api.socketApi}?x-api-key=${config.api.socketKey}&sub=${encodedSub}&lat=${0.0}&lon=${0.0}`);

    socket.onopen = () => {
      setIsReady(true);
      if (socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify(filtersOpts));
        filtersSent.current = true;
      }
    };

    socket.onclose = () => {
      setIsReady(false);
      filtersSent.current = false;
    };

    socket.onmessage = (message) => {
      try {
        const parsedMessage = JSON.parse(message.data);
        const action = parsedMessage.action;

        if (!action) {
          setListServices(parsedMessage);
          setLoading(false);
          return;
        }

        if (allowedActions.includes(action)) {
          socket.send(JSON.stringify(filtersOpts));
        }
      } catch (error) {
        console.error("Failed to parse message:", error);
      }
    };

    ws.current = socket;

    return () => {
      socket.close();
    };
  }, [uuid]);

  useEffect(() => {
    if (ws.current && isReady && ws.current.readyState === WebSocket.OPEN) {
      ws.current.send(JSON.stringify(filtersOpts));
      filtersSent.current = true;
    }
  }, [filtersOpts, reloadList]);

  const ret = [isReady, listServices, ws.current?.send.bind(ws.current)];

  return (
    <WebsocketContext.Provider value={ret}>
      {children}
    </WebsocketContext.Provider>
  );
};
